import React, { useState } from 'react';
import './ShopifyFeatures.css';

const ShopifyFeatures: React.FC = () => {
  const [expandedCard, setExpandedCard] = useState<number | null>(null);

  const toggleDescription = (index: number) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  const features = [
    {
      id: 1,
      number: '01',
      title: 'Real-Time Shopify Sync',
      icon: (
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="12" y="12" width="36" height="36" rx="4" fill="#95BF47" />
          <rect x="16" y="16" width="28" height="28" rx="2" fill="#ffffff" />
          <text x="30" y="38" textAnchor="middle" fill="#95BF47" fontSize="24" fontWeight="700" fontFamily="Arial, sans-serif">
            S
          </text>
        </svg>
      ),
      bullets: [
        'Live Shopify order synchronisation',
        'SKU-level inventory visibility',
        'Automatic order status updates',
      ],
    },
    {
      id: 2,
      number: '02',
      title: 'Next-Day Fulfilment',
      icon: (
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="12" y="12" width="36" height="36" rx="18" fill="#f58030" />
          <circle cx="30" cy="30" r="14" stroke="#ffffff" strokeWidth="2" fill="none" />
          <line x1="30" y1="30" x2="30" y2="18" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" />
          <line x1="30" y1="30" x2="40" y2="30" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" />
          <circle cx="30" cy="18" r="2" fill="#ffffff" />
          <circle cx="40" cy="30" r="2" fill="#ffffff" />
        </svg>
      ),
      bullets: [
        'Defined order cut-off times',
        'Verified fulfilment workflows',
        'On-time carrier allocation',
      ],
    },
    {
      id: 3,
      number: '03',
      title: 'Branded Packaging',
      icon: (
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="12" y="12" width="36" height="36" rx="4" fill="#8B4513" />
          <rect x="16" y="16" width="28" height="28" rx="2" fill="#D2691E" />
          <rect x="20" y="20" width="20" height="20" rx="1" fill="#8B4513" />
          <rect x="24" y="24" width="12" height="12" rx="1" fill="#28479e" />
        </svg>
      ),
      bullets: [
        'Custom branded packaging solutions',
        'Marketing inserts and promotional materials',
        'Product bundling and kitting services',
      ],
    },
    {
      id: 4,
      number: '04',
      title: 'Returns Management',
      icon: (
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="12" y="12" width="36" height="36" rx="4" fill="#8B4513" />
          <rect x="16" y="16" width="28" height="28" rx="2" fill="#D2691E" />
          <circle cx="30" cy="30" r="10" fill="#28479e" />
          <path
            d="M30 22 L30 38 M24 30 L30 22 L36 30"
            stroke="#ffffff"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      bullets: [
        'Structured returns intake process',
        'Product condition grading',
        'Customer experience protection',
      ],
    },
  ];

  return (
    <section className="shopify-features">
      <h2 className="shopify-features-title">
        <span className="shopify-features-title-primary">Shopify Fulfilment Services Built to Scale </span>
        <span className="shopify-features-title-accent">With Your Brand</span>
      </h2>
      <div className="shopify-features-container">
        <div className="shopify-features-grid">
          {features.map((feature) => (
            <div key={feature.id} className="shopify-feature-card">
              <span className="shopify-feature-number" aria-hidden="true">
                {feature.number}
              </span>
              <div className="shopify-feature-head">
                <div className="shopify-feature-icon">{feature.icon}</div>
                <h3 className="shopify-feature-title">{feature.title}</h3>
              </div>
              <ul className="shopify-feature-bullets">
                {feature.bullets.map((bullet, index) => (
                  <li key={index} className="shopify-feature-bullet">
                    {bullet}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="shopify-features-mobile-slider">
          {features.map((feature, i) => (
            <div key={feature.id} className="shopify-features-mobile-slide">
              <div className="shopify-features-mobile-card">
                <span className="shopify-feature-number" aria-hidden="true">
                  {feature.number}
                </span>
                <div className="shopify-feature-head">
                  <div className="shopify-feature-icon">{feature.icon}</div>
                  <p className="shopify-feature-title shopify-feature-title-mobile">{feature.title}</p>
                </div>

                {expandedCard === i && (
                  <ul className="shopify-feature-bullets shopify-feature-bullets-mobile">
                    {feature.bullets.map((bullet, index) => (
                      <li key={index} className="shopify-feature-bullet">
                        {bullet}
                      </li>
                    ))}
                  </ul>
                )}

                <button
                  type="button"
                  className="shopify-feature-show-more-btn"
                  onClick={() => toggleDescription(i)}
                  aria-expanded={expandedCard === i}
                >
                  {expandedCard === i ? 'Show Less' : 'Show More'}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ShopifyFeatures;
